export default function pushMinRepeaterInstances (arr) {
    return arr.map(item => {

        if (item.schema && item.schema.length && item.subForm.min != 0 && !item.children.length) {
            
            for (let i = 0; i < +item.subForm.min; i++) {
                const schema = item.schema.map(item => {
                    let _item = { ...item }
                    _item.key = _item.key + '_[i]' + '__' + i

                    return _item
                })

                item.children.push(schema)
            }
        }

        if (item.type === 'group' && item.children.length) {
            item.children = pushMinRepeaterInstances(item.children)
            
            return item
        }

        return item
    })
}


// WEBPACK FOOTER //
// ./src/helpers/push-min-repeater-instances.js